import {
    AlertSuccessDefaultProps,
    ConfirmAndExecutePanelDefaultProps,
    CUITFieldDefaultProps,
    DataGridDefaultProps,
    DataGridLabels, DataGridToolbarDefaultProps, DataMapDefaultDataGridProps,
    DataMapDefaultProps, DataViewDefaultProps, DateInputFieldDefaultProps, EmailFieldDefaultProps,
    EmailServiceConfigurationFormDefaultProps,
    EntityFormDefaultProps, FilesUploadFormDefaultProps,
FileUploaderDefaultProps,     ImportEntityDataFormDefaultProps,
    ImportEntityDataLabels,
    LoginDefaultProps, LoginModalDefaultProps, LookupDefaultProps,
    LookupFormDefaultProps, LookupSelectDefaultProps, MenuDefaultProps, MenuPanelDefaultProps,
    MicromUsersFormDefaultProps, MicromUsersGroupsFormDefaultProps, MicromUsersGroupsMenusColumnsOverridesLabelsDefaultProps,
    MicromUsersGroupsMenusDisableMenusLabels, MicromUsersGroupsMenusEnableMenusLabels, MicromUsersGroupsMenusEntityDefaultProps,
    PhoneFieldDefaultProps, RecoverPasswordDefaultProps, RecoverPasswordEmailDefaultProps, UrlFieldDefaultProps, UseFieldConfigurationDefaultProps, UseLookupFormDefaultProps
} from "@mcurros2/microm";

export function Translate() {

    const dgLabels: DataGridLabels = {
        addLabel: "Agregar",
        editLabel: "Editar",
        deleteLabel: "Eliminar",
        viewLabel: "Ver",
        rowsReturnedLabel: "Cantidad de filas:",
        selectedRowsLabel: "filas seleccionadas.",
        limitLabel: "Límite",
        rowsLabel: "filas",
        unlimitedLabel: "Ilimitado",
        AreYouSureLabel: "Está seguro?",
        YouMustSelectOneOrMoreRecordsToExecuteAction: "Debe seleccionar uno o más registros para ejecutar la acción",
        closeLabel: "Cerrar",
        recordsLabel: "registros",
        warningLabel: "Advertencia",
        YouMustSelectOneOrMoreRecordsToDelete: "Debe seleccionar uno o más registros a eliminar",
        YouWillDeleteLabel: "Usted va a eliminar",
        YouMustSelect: "Debe seleccionar",
        YouMustSelectAtLeast: "Debe seleccionar al menos",
        YouMustSelectBetween: "Debe seleccionar entre",
        YouMustSelectMaximum: "Debe seleccionar un máximo de",
        recordLabel: "registro",
    };

    DataGridDefaultProps.labels = dgLabels;
    DataGridToolbarDefaultProps.searchPlaceholder = "Ingrese el texto a buscar";
    DataGridToolbarDefaultProps.refreshTooltip = "Refrescar";
    DataGridToolbarDefaultProps.exportTooltip = "Exportar Excel";
    DataGridToolbarDefaultProps.selectRowsTooltip = "Seleccionar ítems";
    DataGridToolbarDefaultProps.importTooltip = "Importar datos de archivo CSV";

    LoginDefaultProps.forgotLabel = "Olvidó su contraseña?";
    LoginDefaultProps.loginErrorMessage = "Usuario o contraseña inválidos";
    LoginDefaultProps.passwordLabel = "Clave";
    LoginDefaultProps.passwordPlaceholder = "Su contraseña";
    LoginDefaultProps.rememberLabel = "Recordarme";
    LoginDefaultProps.signInButtonLabel = "Iniciar sesión";
    LoginDefaultProps.userLabel = "Usuario";
    LoginDefaultProps.userPlaceholder = "Nombre de usuario";
    LoginDefaultProps.confirmRecoveryEmailTitle = "Email de recuperación";

    LoginModalDefaultProps.title = "Iniciar sesión";

    EntityFormDefaultProps.CancelText = "Cancelar";
    EntityFormDefaultProps.OKText = "Guardar";
    EntityFormDefaultProps.CloseText = "Cerrar";
    EntityFormDefaultProps.invalidFieldsLabel = "Algunos campos tienen valores inválidos. Por favor revise el formulario"

    ConfirmAndExecutePanelDefaultProps.cancelButtonText = "Cancelar";

    UseFieldConfigurationDefaultProps.requiredMessage = "Dato requerido";

    MicromUsersFormDefaultProps.disabledFalseLabel = "El usuario está habilitado";
    MicromUsersFormDefaultProps.disabledTrueLabel = "El usuario está DESHABILITADO";
    MicromUsersFormDefaultProps.lockedRemainingLabel = "El usuario está bloqueado. Se desbloqueará automáticamente en";
    MicromUsersFormDefaultProps.userEnabledLabel = "Habilitado";
    MicromUsersFormDefaultProps.userDisabledLabel = "DESHABILITADO";
    MicromUsersFormDefaultProps.logonAttemptsStatusDescription = "El usuario registra intentos fallidos de inicio de sesión";
    MicromUsersFormDefaultProps.logonAttemptsStatusTitle = "Intentos de incio de sesión fallidos";

    MicromUsersFormDefaultProps.minutesLabel = "minutos";
    MicromUsersFormDefaultProps.willUnlockInNextLogonLabel = "El período de bloqueo automático ha finalizado. El usuario será desbloqueado en el próximo inicio de sesión.";
    MicromUsersFormDefaultProps.lockedTitleLabel = "El usuario está bloqueado";

    LookupSelectDefaultProps.editLabel = "Editar";
    LookupSelectDefaultProps.requiredLabel = "Debe seleccionar un valor de la lista";
    LookupDefaultProps.requiredLabel = "Debe seleccionar un valor de la lista";
    UseLookupFormDefaultProps.selectLabel = "Seleccionar";
    LookupFormDefaultProps.okLabel = "Seleccionar";
    LookupFormDefaultProps.cancelLabel = "Cancelar";
    LookupFormDefaultProps.helpMessage = "Seleccione un valor de la lista o ingrese un valor para buscar";

    LookupDefaultProps.requiredLabel = "Debe seleccionar un valor de la lista";

    CUITFieldDefaultProps.invalidMessage = "El CUIT/CUIL ingresado no es válido";
    EmailFieldDefaultProps.invalidMessage = "El Email ingresado no es válido";
    PhoneFieldDefaultProps.invalidMessage = "El número telefónico ingresado no es válido";
    UrlFieldDefaultProps.invalidMessage = "La URL ingresada no es válida";

    FilesUploadFormDefaultProps.okLabel = "Finalizar";
    FilesUploadFormDefaultProps.helpMessage = "Seleccione los archivos que desea adjuntar";

    FileUploaderDefaultProps.AttachUpToText = "Adjuntar hasta";
    FileUploaderDefaultProps.EachFileShouldNotExceedText = "Cada archivo no debe exceder";
    FileUploaderDefaultProps.FilesText = "archivos";
    FileUploaderDefaultProps.UploadText = "Arrastre archivos aquí o haga clic para seleccionar";
    FileUploaderDefaultProps.cancelLabel = "Cancelar";

    MenuDefaultProps.searchLabel = "Buscar";
    MenuPanelDefaultProps.searchLabel = "Buscar";

    DataViewDefaultProps.labels = {
        ...dgLabels,
        resultLimitLabel: "Los resultados están limitados a %s registros. Utilice un criterio de búsqueda para reducir la cantidad de registros devueltos.",
        fetchingDataLabel: "Obteniendo datos...",
        loadMoreLabel: "Mostrar más",
        noRecordsFoundLabel: "No se encontraron registros",
    };



    DateInputFieldDefaultProps.valueFormat = "DD/MM/YYYY";
    DateInputFieldDefaultProps.locale = "es";

    DataMapDefaultDataGridProps.labels = {
        ...dgLabels,
    }

    DataMapDefaultProps.labels!.mapTabLabel = "Mapa";

    MicromUsersGroupsFormDefaultProps.groupTabLabel = "Perfil";
    MicromUsersGroupsFormDefaultProps.menusTabLabel = "Permisos de menú";
    MicromUsersGroupsFormDefaultProps.membersTabLabel = "Miembros";

    MicromUsersGroupsMenusEntityDefaultProps.title = "Permisos";
    MicromUsersGroupsMenusEntityDefaultProps.helpText = "Acceso configurado a los menues del sistema";

    MicromUsersGroupsMenusEnableMenusLabels.buttonLabel = "Permitir acceso";
    MicromUsersGroupsMenusEnableMenusLabels.allowAccessToSelectedMenuItems = "Permitir acceso a los ítems seleccionados";
    MicromUsersGroupsMenusEnableMenusLabels.areYouSure = "Está permitiendo el acceso a los ítems de menú seleccioandos. ¿Está seguro?";
    MicromUsersGroupsMenusEnableMenusLabels.title = "Habilitar acceso";

    MicromUsersGroupsMenusDisableMenusLabels.buttonLabel = "Denegar acceso";
    MicromUsersGroupsMenusDisableMenusLabels.denyAccessToSelectedMenuItems = "Denegar acceso a los ítems seleccionados";
    MicromUsersGroupsMenusDisableMenusLabels.areYouSure = "Está denegando el acceso a los ítems de menú seleccioandos. ¿Está seguro?";
    MicromUsersGroupsMenusDisableMenusLabels.title = "Denegar acceso";

    MicromUsersGroupsMenusColumnsOverridesLabelsDefaultProps.granted = "Permitido";
    MicromUsersGroupsMenusColumnsOverridesLabelsDefaultProps.denied = "Denegado";


    ImportEntityDataFormDefaultProps.importInfoLabel = "Importar un archivo CSV con datos para";
    ImportEntityDataFormDefaultProps.csvInstructionsLabel = "El archivo CSV debe contener una cabecera con los nombres de columna indicados en 'Nombre de Columna':";
    ImportEntityDataFormDefaultProps.columnHeaderLabel = "Nombre de columna";
    ImportEntityDataFormDefaultProps.dataNameLabel = "Corresponde a";
    ImportEntityDataFormDefaultProps.contentLabel = "Contenido";
    ImportEntityDataFormDefaultProps.dataTypeLabel = "Tipo de dato";
    ImportEntityDataFormDefaultProps.errorReadingFileLabel = "Error al leer el archivo";
    ImportEntityDataFormDefaultProps.emptyCSVFileLabel = "El archivo CSV está vacío";
    ImportEntityDataFormDefaultProps.missingColumnsLabel = "Columnas faltantes:";
    ImportEntityDataFormDefaultProps.dateFormatLabel = "* Las fechas deben tener el formato AAAA-MM-DD";
    ImportEntityDataFormDefaultProps.numberFormatLabel = "* Los números con decimales deben usar '.' como separador";
    ImportEntityDataFormDefaultProps.downloadSampleLabel = "Descargar un CSV de muestra";
    ImportEntityDataFormDefaultProps.importButtonLabel = "Importar";
    ImportEntityDataFormDefaultProps.importHelpAndInstructionsLabel = "Ayuda e Instrucciones";
    ImportEntityDataFormDefaultProps.recordsImportedSusccessfullyLabel = "Registros importados con éxito";
    ImportEntityDataFormDefaultProps.recordsNotImportedDueToErrorsLabel = "Registros no importados debido a errores";
    ImportEntityDataFormDefaultProps.importTheCSVFileLabel = "Importe el archivo CSV haciendo click o arrastrando el archivo, luego haga clic en";
    ImportEntityDataFormDefaultProps.importedFileLabel = "Archivo importado:";

    ImportEntityDataLabels.Title = "Importar datos";
    ImportEntityDataLabels.HelpText = "Importar un archivo .CSV con datos para esta entidad";

    EmailServiceConfigurationFormDefaultProps.recoveryTABLabel = "Recuperación de contraseña";
    EmailServiceConfigurationFormDefaultProps.settingsTABLabel = "Configuración de email";
    EmailServiceConfigurationFormDefaultProps.setDefaultMessageButtonLabel = "Establecer mensaje por defecto";

    RecoverPasswordDefaultProps.changedSuccessfullyMessage = "La contraseña ha sido cambiada exitosamente";
    RecoverPasswordDefaultProps.changeErrorMessage = "Error al cambiar la contraseña";
    RecoverPasswordDefaultProps.changePasswordLabel = "Cambiar contraseña";
    RecoverPasswordDefaultProps.passwordLabel = "Nueva contraseña";
    RecoverPasswordDefaultProps.signInButtonLabel = "Iniciar sesión";
    RecoverPasswordDefaultProps.userLabel = "Usuario";
    RecoverPasswordDefaultProps.userPlaceholder = "Nombre de usuario";
    RecoverPasswordDefaultProps.passwordPlaceholder = "Su nueva contraseña";

    RecoverPasswordEmailDefaultProps.emailSendErrorMessage = "Error al enviar el email";
    RecoverPasswordEmailDefaultProps.emailSentSuccessfullyMessage = "Email enviado exitosamente";
    RecoverPasswordEmailDefaultProps.goBackToHomePageLabel = "Volver a la página de inicio";
    RecoverPasswordEmailDefaultProps.sendRecoveryEmailLabel = "Enviar email de recuperación";
    
    RecoverPasswordEmailDefaultProps.userLabel = "Usuario";
    RecoverPasswordEmailDefaultProps.userPlaceholder = "Nombre de usuario";

    AlertSuccessDefaultProps.title = "Éxito";

}


